import get from "lodash/get";
import round from "lodash/round";
import Locale from "@/Services/Locale";

export default {
    methods: {
        money(value) {
          const currency = this.$store.state.currency;

          return round(Number(value) / 100, currency.decimals).toFixed(currency.decimals) + ' ' + currency.symbol;
        },

        __(key) {
          return Locale.translate(key);
        },

        scrollToTarget(element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - get(window.centralAdminOrderForm, 'shopOrderComponent.config.headerOffset', 0);

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        },
    },
}
